import { ReactNode } from "react";

type GlowWrapperProps = {
  children: ReactNode;
  color?: 'teal' | 'blue' | 'purple' | 'green';
  intensity?: 'low' | 'medium' | 'high';
};

export function GlowWrapper({ 
  children, 
  color = 'teal', 
  intensity = 'medium' 
}: GlowWrapperProps) {
  // Set base opacity based on intensity
  const baseOpacity = intensity === 'low' ? 0.1 : intensity === 'medium' ? 0.2 : 0.3;
  
  // Get color values based on prop
  const getColorValue = () => {
    switch (color) {
      case 'teal': return '0,194,203';
      case 'blue': return '0,122,255';
      case 'purple': return '175,82,222';
      case 'green': return '52,199,89';
      default: return '0,194,203';
    }
  };

  const colorValue = getColorValue();
  const glowSize = intensity === 'low' ? '8px' : intensity === 'medium' ? '12px' : '16px';
  const glowOpacity = baseOpacity + 0.1;

  return (
    <div className="relative inline-block">
      {/* Glow effect */}
      <div 
        className="absolute -inset-0.5 rounded-lg" 
        style={{ 
          opacity: glowOpacity,
          background: `linear-gradient(45deg, rgba(${colorValue},0.4) 0%, rgba(${colorValue},0.1) 100%)`,
          filter: `blur(${glowSize})`,
          zIndex: -1
        }}
      ></div>
      
      {/* Content */}
      {children}
    </div>
  );
}
